import C from 'utils/values/constant.util';

// Set in SalonRoute on login
let tokenRefreshTimer = null;

const TOKEN_REFRESHER_TIMER = C({
  // eslint-disable-next-line no-return-assign
  set: (value) => void (tokenRefreshTimer = value),
  get: () => tokenRefreshTimer,
});

// noinspection JSUnusedGlobalSymbols
export default TOKEN_REFRESHER_TIMER;
